export { default } from './ResolutionPicker';

export const PRESET_RESOLUTIONS = [
  { width: 1920, height: 1080, label: '1920×1080' },
  { width: 1080, height: 1920, label: '1080×1920' },
];
